import React from "react";

import "./App.css";

// MUI Library
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Route, Routes } from "react-router-dom";

// Components
import Header from "./components/parts/Header";
import Footer from "./components/parts/Footer";
import Home from "./components/Home";

// Fonts
const theme = createTheme({
  typography: {
    fontFamily: ["Agustina", "Roboto"],
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Header />

        <Routes>
          <Route path="/" element={<Home />} />

        </Routes>

        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
